<template>
  <div class="my-4 rounded-lg border border-blue-200 bg-blue-50 p-4 dark:border-blue-800 dark:bg-blue-900/20">
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <h5 class="text-sm font-medium text-blue-900 dark:text-blue-100">
          ¿Requiere factura? (IVA)
        </h5>
        <span
          v-if="ivaEnabled"
          class="rounded-full bg-blue-100 px-2 py-1 text-xs text-blue-800 dark:bg-blue-800 dark:text-blue-200"
        >
          {{ ivaRatePercent }}%
        </span>
      </div>
      <button
        type="button"
        class="relative inline-flex h-6 w-11 cursor-pointer flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        :class="ivaEnabled ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'"
        role="switch"
        :aria-checked="ivaEnabled"
        @click="$emit('toggle-iva', !ivaEnabled)"
      >
        <span class="sr-only">Activar IVA</span>
        <span
          :class="ivaEnabled ? 'translate-x-5' : 'translate-x-0'"
          class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
        />
      </button>
    </div>

    <div
      v-if="showIvaSummary"
      class="mt-3 border-t border-blue-200 pt-3 dark:border-blue-700"
    >
      <div class="grid grid-cols-3 gap-2 text-xs">
        <div class="text-center">
          <p class="font-medium text-blue-600 dark:text-blue-400">
            Subtotal
          </p>
          <p class="font-bold text-blue-900 dark:text-blue-100">
            ${{ taxableSubtotal.toFixed(2) }}
          </p>
        </div>
        <div class="text-center">
          <p class="font-medium text-blue-600 dark:text-blue-400">
            IVA ({{ ivaRatePercent }}%)
          </p>
          <p class="font-bold text-blue-900 dark:text-blue-100">
            ${{ normalizedIvaAmount.toFixed(2) }}
          </p>
        </div>
        <div class="text-center">
          <p class="font-medium text-blue-600 dark:text-blue-400">
            Total
          </p>
          <p class="font-bold text-blue-900 dark:text-blue-100">
            ${{ orderTotal.toFixed(2) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  ivaEnabled?: boolean;
  ivaRate?: number;
  subtotal?: number;
  ivaAmount?: number;
  orderTotal: number;
  deliveryFee?: number;
  currentDiscount?: number;
}

defineEmits<{
  'toggle-iva': [enabled: boolean];
}>();

const props = defineProps<Props>();

const ivaRatePercent = computed(() => (props.ivaRate || 0.16) * 100);
const normalizedIvaAmount = computed(() => props.ivaAmount || 0);
const taxableSubtotal = computed(() => (props.subtotal || 0) - (props.currentDiscount || 0) + (props.deliveryFee || 0));
const showIvaSummary = computed(() => Boolean(props.ivaEnabled && props.subtotal));
</script>
